// extracted by mini-css-extract-plugin
export default {"root":"CompanyLinks_root__PWYHB","linkContainer":"CompanyLinks_linkContainer__eDlI0","link":"CompanyLinks_link__xVjXW","container":"CompanyLinks_container__u1IZR"};